import React from "react";
import image from "../../assets/images/bear.svg";
import styles from "../../styles/Profile/TransactionItem.module.css";
import { BsThreeDotsVertical } from "react-icons/bs";
import { formatPrice } from "../../helpers/format";
import NumberFormat from "react-number-format";
const TransactionItem = ({
  id,
  desc,
  date,
  amt,
  type,
  currencySymbol,
  exchangeRate,
}) => {
  return (
    <div className={styles.transactionItem}>
      <section className={styles.section1}>
        <img src={image} alt="coinstorey" />
        <div className={styles.subsection}>
          <p>{desc}</p>
          <p>{date}</p>
        </div>
        <div className={styles.icon}>
          <BsThreeDotsVertical />
        </div>
      </section>
      <section className={styles.section2}>
        <div>
          <p>Transaction ID</p>
          <p>{id}</p>
        </div>
        <div>
          <p
            style={{
              color:
                type === "CREDIT"
                  ? "rgba(69, 170, 67, 1)"
                  : type === "DEBIT"
                  ? "#E93848"
                  : "#8d0792",
            }}
          >
            <NumberFormat
              value={formatPrice(amt)}
              displayType={"text"}
              thousandSeparator={true}
              prefix="₹"
            />
          </p>
          <p>{type}</p>
        </div>
        {/* {type==="CREDIT"&&<p>{amt}</p>}
                {type==="DEBIT"&&<p>{amt}</p>} */}
      </section>
    </div>
  );
};

export default TransactionItem;
